export const fetchAds = async (placement = "") => {
    const API_URL = process.env.REACT_APP_BKND_URL;
    const res = await fetch(`${API_URL}/get-ads.php?placement=${placement}`);
    return await res.json();
};